package link.erpango.quip.data.remote.repository.catalog

import kotlinx.serialization.Serializable

@Serializable
data class CatalogResponseDto(
    val server_time: Long,
    val brands: List<VehicleBrandDto>
)

@Serializable
data class VehicleBrandDto(
    val id: Long,
    val name: String,
    val updated_at: Long,
    val models: List<VehicleModelDto>
)

@Serializable
data class VehicleModelDto(
    val id: Long,
    val name: String,
    val updated_at: Long
)
